export const INTERNAL_SERVER_ERROR =
  "Something went wrong. Please try again or contact support";
export const FAILED_TO_LOAD_MESSAGE = "Failed to load message";
export const DEFAULT_ERROR_MESSAGE = {
  status: "FAILED",
  responseMessage: INTERNAL_SERVER_ERROR,
};
export const NO_RECORDS_FOUND_ERROR_MESSAGE = "No records were found.";